var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calendar-main',{ref:"calendarMainRef",attrs:{"add-permission":_vm.canManageEvent,"delete-permission":_vm.canManageEvent,"edit-permission":_vm.canManageEvent,"get-categories":_vm.getCategories,"get-events":_vm.getEvents},on:{"delete-event":_vm.onDeleteEventHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }